import { render, staticRenderFns } from "./VCardContent.vue?vue&type=template&id=4a963943&scoped=true&lang=pug&functional=true"
import script from "./VCardContent.vue?vue&type=script&lang=js"
export * from "./VCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4a963943",
  null
  
)

export default component.exports